import { useSidebar } from '../stores/sidebar';

const sidebarMixin = {
    methods: {
        $sidebar(action) {
            const sidebarStore = useSidebar();
            switch(action) {
                case 'show':
                    sidebarStore.show()
                    break;
                case 'hide':
                    sidebarStore.hide()
                    break;
                case 'isOpen':
                    return sidebarStore.openDialog;
                    break;
            }
        }
    }
}

export default sidebarMixin;